import { useTranslation } from "react-i18next";
import CarBrandLogo from "./CarBrandLogo";
import { FaTrashAlt } from "react-icons/fa";

const MyCarItem=({vehicleData, isBelongtoSub, setVehicle ,onRemove})=>{
  const {t}=useTranslation();
    const handleClick = () => {
        setVehicle(vehicleData); // Calls the `handleSetVeh` function passed as a prop.
      };

return (
<div
  onClick={handleClick}
  className={`bg-white rounded-xl shadow-md p-4 w-full max-w-md space-y-3 ${
    isBelongtoSub ? 'ring-4 ring-orange-400' : ''
  }`}
>
  {/* Top Section */}
  <div className="flex items-center justify-between">
    <div className="flex items-center space-x-3">
      <CarBrandLogo model={vehicleData?.model} />
      <div>
        <p className="text-base font-semibold text-gray-900">{vehicleData?.model}</p>
        <p className="text-sm text-gray-400">model : {vehicleData?.year}</p>
      </div>
    </div>
    <button onClick={()=>onRemove(vehicleData)} className="text-red-500 hover:text-red-700">
      <FaTrashAlt className="w-5 h-5" />
    </button>
  </div>

  {/* Divider */}
  <hr className="border-t border-gray-200" />

  {/* Bottom Info Row */}
  <div className="flex justify-between text-center text-sm text-gray-700">
    {/* Plate Number */}
    <div className="flex-1">
      <p className="font-medium">{vehicleData?.plate_number}</p>
      <p className="text-gray-400">{t('plateNumber')}</p>
    </div>

    {/* Color */}
    <div className="flex-1">
      <div className="flex items-center justify-center gap-2">
        <span
          className="w-3 h-3 rounded-full"
          style={{ backgroundColor: vehicleData?.color }}
        ></span>
        <span className="capitalize">{vehicleData?.color_name || 'Color'}</span>
      </div>
      <p className="text-gray-400">{t('color')}</p>
    </div>

    {/* Vehicle Type */}
    <div className="flex-1">
      <p className="capitalize">{vehicleData?.registration}</p>
      <p className="text-gray-400">{t('vehicletype')}</p>
    </div>
  </div>
</div>

)
}
export default MyCarItem;